module.exports = __webpack_public_path__ + "static/media/TXT.daf744f8.svg";